import { useRef } from "react";
import { Pagination as PaginationModel } from "src/types/experiences/leadsAndReports";

export const useStablePagination = <T extends PaginationModel>(
  data: T | undefined,
): T | undefined => {
  const last = useRef<T | undefined>(undefined);
  if (data !== undefined) last.current = data;
  return data ?? last.current;
};
